import { render, staticRenderFns } from "./ContactsCustomerList.vue?vue&type=template&id=5fb8cff8&scoped=true"
import script from "./ContactsCustomerList.vue?vue&type=script&lang=js"
export * from "./ContactsCustomerList.vue?vue&type=script&lang=js"
import style0 from "./ContactsCustomerList.vue?vue&type=style&index=0&id=5fb8cff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb8cff8",
  null
  
)

export default component.exports